module.exports = __webpack_public_path__ + "img/slide2.4c5166a0.png";